import React from "react";

import InfoTable, { InfoRow } from "../../InfoTable/InfoTable";

const Info = ({ md5, sha1, vhash, ssdeep, file_type, magic, interestingStrings = [] }) => {
  // Eliminate duplications
  const uniqueInterestingStrings = interestingStrings.filter(
    (filterData, index, arr) =>
      arr.findIndex((data) => filterData.string === data.string) === index,
  );

  return (
    <div className="files-info__block">
      <InfoTable>
        <InfoRow label="MD5" value={md5} mono={true} />
        <InfoRow label="SHA-1" value={sha1} mono={true} />
        <InfoRow label="Vhash" value={vhash} mono={true} />
        <InfoRow label="SSDEEP" value={ssdeep} mono={true} copyable={true} />
        <InfoRow label="Type" value={file_type} />
        <InfoRow label="Magic" value={magic} />
      </InfoTable>
      {
        <>
          <p className="files-info__strings-title">Interesting Strings</p>
          <div className="analysis-reports__body-block__strings-container">
            {uniqueInterestingStrings.map((interestingString, i) => (
              <p key={i} className="analysis-reports__body-block__string">
                <span style={{ color: "var(--text-color-card)" }}>{i + 1}</span> -{" "}
                {interestingString.string}
              </p>
            ))}
          </div>
        </>
      }
    </div>
  );
};

export default Info;
